var showDebug = false;

require([
	"jquery",
	"flickity",
	"root/Base/Js/MbiImageSize",
	"root/Base/Js/MbiMediaQuery",
	"isotope",
	"project/MbiConfig",
	"project/MbiGoogleMaps",
	"debounce",
	"root/Base/Js/MbiBrowser",
	"root/Base/Js/Vendor/PictureFill",
	"root/Assets/Js/Templates",
	"root/Base/Js/Vendor/Modernizr",
	"root/Assets/Js/Vendor/cookie"
], function($, Flickity, mbiImageSize, mbiMq, Isotope, mbiConfig, mbiGoogleMaps) {
	"use strict";

	mbiImageSize.init();

	if (!window.requestAnimationFrame) {
		window.requestAnimationFrame = (function() {
			return (
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(
					/* function FrameRequestCallback */ callback,
					/* DOMElement Element */ element
				) {
					window.setTimeout(callback, 1000 / 60);
				}
			);
		})();
	}

	var lastPosition =
		(document.documentElement && document.documentElement.scrollTop) ||
		document.body.scrollTop;
	var reachedBottomFirstTime = true;

	function reachedBottom(lastPosition) {
		var body = document.body,
			html = document.documentElement;
		var height =
			Math.max(
				body.scrollHeight,
				body.offsetHeight,
				html.clientHeight,
				html.scrollHeight,
				html.offsetHeight
			) - $(window).height();

		if (lastPosition < height) {
			$("html").removeClass("reachedBottom");
		} else {
			if (reachedBottomFirstTime) {
				//reachedBottomFirstTime = false;
				reachedBottomFirstTime = true;
				$("html").addClass("reachedBottom");
			}
		}

		if (lastPosition >= 1) {
			$("html").removeClass("reachedTop");
		} else {
			$("html").addClass("reachedTop");
		}

		if (
			!$("html").hasClass("reachedTop") &&
			!$("html").hasClass("reachedBottom")
		) {
			$("html").addClass("inBetweenScroll");
		} else {
			$("html").removeClass("inBetweenScroll");
		}
	}

	var loop = function() {
		requestAnimationFrame(loop);

		var check =
			(document.documentElement && document.documentElement.scrollTop) ||
			document.body.scrollTop;

		if (lastPosition !== check) {
			lastPosition = check;

			reachedBottom(lastPosition);
		}
	};

	reachedBottom(lastPosition);
	loop();

	$(document).on("click", ".js_openDetail", function() {
		// $('.people').addClass('is_invisible');
		// $(this).addClass('is_active');
		// var target = $(this).attr('data-for');
		// if($(document).find('.js_openDetail').hasClass('is_active')) {
		// 	$(document).find('.people-detail').removeClass('is_open');
		// 	setTimeout(function(){
		// 		$('.people-detail[data-target="'+target+'"]').addClass('is_open');
		// 	},501);
		// } else {
		// 	$('.people-detail[data-target="'+target+'"]').addClass('is_open');
		// }
		// if ($(this).hasClass('is_active')) {
		// 	$(this).removeClass('is_active');
		// } else {
		// 	$('.js_openDetail').removeClass('is_active');
		// 	$(this).addClass('is_active');
		// }
		// $(this).addClass('is_active');
		if (!$(this).hasClass("is_active")) {
			$(this).addClass("is_active");
		}
	});

	$(document).on("click", ".js_closeDetail", function(e) {
		$(this)
			.closest(".js_openDetail")
			.removeClass("is_active");
		e.preventDefault();
		e.stopPropagation();
	});

	$("html").addClass("domLoaded");

	/*=============================
 =            timmi            =
 =============================*/

	setTimeout(function() {
		if ($(".section-grid").length > 0) {
			var iso = new Isotope(".grid-wrapper", {
				layoutMode: "masonry",
				// layoutMode: 'fitRows',
				// resizeable:false,
				itemSelector: ".grid-item",
				// fitWidth:true
				stagger: 30,
				percentPosition: true,
				masonry: {
					columnWidth: ".grid-sizer",
					// 'gutter': 25,
					gutter: ".gutter-sizer"
					// columnWidth: 136,
				}
			});

			$(document).on("click", ".js_filter", function() {
				var activeFilters = "";

				if ($(this).hasClass("tag-item")) {
					if ($(this).hasClass("is_active")) {
						$(".tag-item").removeClass("is_active");
					} else {
						$(".tag-item").removeClass("is_active");
						$(this).addClass("is_active");
					}
				}

				$(".js_filter").each(function(index, el) {
					if ($(el).hasClass("is_active")) {
						activeFilters += $(el).attr("data-slug");
					}
				});

				iso.arrange({ filter: activeFilters });
			});
		}
	}, 200);



	function initSliders(action) {
		if ($(".fleisch-slider").length) {
			$(".fleisch-slider").each(function(i) {
				if ($(this).children().length > 1) {
					var count = i + 1;

					if ("lap-" in mbiMq.mqArea) {
					} else {
					}
					var actOpt = {
						contain: true,
						percentPosition: true,
						prevNextButtons: false,
						// setGallerySize: false,
						// adaptiveHeight: true,
						cellAlign: "center",
						// cellAlign: leftOffset / sliderWidth,
						pageDots: true,
						wrapAround: false,
						groupCells: 1
					};

					if (action == "reload") {
						// var destroy = '.fleisch-slider'+count;
						var flkty = Flickity.data(".fleisch-slider-" + count);
						flkty.destroy();
					}

					initSlider(".fleisch-slider-" + count, actOpt);
				}
			});
		}
	}

	initSliders("init");

	$(window).resize(
		$.debounce(250, function() {
			initSliders("reload");
			mbiImageSize.init();
		})
	);

	function initSlider(e, o) {
		var elem = document.querySelector(e);
		var options = {};
		if (o != undefined) {
			options = o;
		} else {
			options = {
				cellAlign: "left",
				contain: true,
				// accessibility: false,
				percentPosition: true,
				autoPlay: 5000,
				// freeScroll: true,
				prevNextButtons: false,
				setGallerySize: true,
				// adaptiveHeight: true,
				pageDots: false,
				wrapAround: true
			};
		}

		setTimeout(function() {
			var flkty = new Flickity(elem, options);

			var $prevB = $(elem)
				.parent()
				.next()
				.find(".button-prev");
			var $nextB = $(elem)
				.parent()
				.next()
				.find(".button-next");

			var $prevB = $(elem)
				.closest(".section")
				.find(".button-prev");
			var $nextB = $(elem)
				.closest(".section")
				.find(".button-next");
			var buttons = [$prevB, $nextB];

			var event = "click";
			$.each(buttons, function(index, el) {
				$(el).unbind(event);
				$(el).on(event, function(evt) {
					evt.stopPropagation();
					evt.preventDefault();
					if ($(this).hasClass("button-next")) {
						flkty.next(true, false);
					} else {
						flkty.previous(true, false);
					}
				});
			});
		}, 100);
		// setTimeout(function() {
		//     mbiImageSize.init();
		// }, 150);
	}

	/*==============================
    =            cookie            =
    ==============================*/
    setTimeout(function() {
        if ($.cookie('cookiemsg') != 'confirmed') {
            $('.cookiemsg').addClass('is_active');
        } else {
            $('.cookiemsg').remove();
        }
    }, 2000);

    $(document).on('click', '.js_savecookie',function(){
        $.cookie('cookiemsg', 'confirmed', { expires: 7, path: '/' });
        $('.cookiemsg').addClass('clicked');
    });


	/*==============================
    =        single-job Map        =
    ==============================*/

    if ($('.section.job-description').length) {

    	var $mapCanvas = $('.mapCanvas'),
    		canvasID = $mapCanvas.attr('id'),
    		latitude = $mapCanvas.attr('data-latitude'),
    		longitude = $mapCanvas.attr('data-longitude');

		mbiConfig.urls = {assets : ASSETS_URL};
		var styles = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}];
		var markerClickedHandler = function(marker, address) {};
		var customMarkerURL = mbiConfig.urls.assets + "/Images/herz.svg";

		var isDraggable         = true;
		var isNavigationControl = true;
		var isScaleControl      = true;
		var isPanControl        = true;
		var isZoomControl       = false;

		if ('pad-' in mbiMq.mqArea) {
			isDraggable         = false;
			isNavigationControl = false;
			isScaleControl      = false;
			isPanControl        = false;
			isZoomControl       = false;
		}

		function initGoogleMaps(canvasID, latitude, longitude) {

			var mapcenter = new google.maps.LatLng(latitude, longitude);
			var args = {

				center: {
					latitude: latitude,
					langtitude: longitude
				},
				mapOptions: {

					zoom: 11,
					center: mapcenter,
					fullscreenControl: true,
					scrollwheel: false,
					mapTypeControl: false,
					navigationControl: isNavigationControl,
					scaleControl: isScaleControl,
					panControl: isPanControl,
					zoomControl: isZoomControl,
					streetViewControl: false,
					draggable: isDraggable,
					mapTypeId: 'ROADMAP',
					styles: styles

				},
				extraOptions: {

					mapCanvasID: canvasID,
					markerIconUrl: customMarkerURL,
					markerIconWidth: 32,
					markerIconHeight: 32,
					markerCurrentLocationIconUrl: customMarkerURL,
					markerCurrentLocationIconWidth: 32,
					markerCurrentLocationIconHeight: 32,
					markerPath: 'CIRCLE',
					showAll: false,
					maxZoomIn: 16,
					maxZoomOut: 16,
					markerClickCallback: markerClickedHandler
				}

			};

			mbiGoogleMaps.init(args);

			var address={
				lat: latitude,
				lng: longitude,
				elementID:canvasID
			};

			var marker = mbiGoogleMaps.createLocationMarker(canvasID,address);

		};

		initGoogleMaps(canvasID,latitude,longitude);


    }


});
define("Assets/Js/Footer.js", function(){});

